<lui-toolbar #topbar>
  <div luiToolbarActionsStart></div>
  <div class="search">
    <label for="" class="search-label colon" i18n>Search our FAQs</label>
    <mat-form-field luiSearchField>
      <input
        type="text"
        matInput
        placeholder="Enter a question, keyword or topic"
        i18n-placeholder
        autocomplete="off"
        [formControl]="searchControl"
        [matAutocomplete]="searchAutocomplete"
      />
      <mat-icon matSuffix svgIcon="search"></mat-icon>

      <mat-autocomplete #searchAutocomplete>
        <mat-optgroup
          *ngFor="let option of searchOptions"
          [label]="option.title"
        >
          <mat-option
            *ngFor="let item of option.questions"
            (onSelectionChange)="onOptionClicked(option.id, item.id)"
          >
            <div class="hstack gap-1">
              {{ item.title }}
            </div>
          </mat-option>
        </mat-optgroup>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div luiToolbarActionsEnd></div>
</lui-toolbar>
